import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

import Login from './pages/Login';
import Home from './pages/Home';
import Municipio from './pages/Municipio';
import Propriedade from './pages/Propriedade';
import Unidades from './pages/Unidades';

const router = createBrowserRouter(
  [
    // { path: '/', element: <Login /> },
    { path: '/home', element: <Home /> },
    { path: '/municipio', element: <Municipio /> },
    { path: '/propriedade', element: <Propriedade /> },
    { path: '/unidades', element: <Unidades /> },
    { path: '/', element: <Login /> },
  ],
  {
    // future: {
    //   v7_startTransition: true,
    // }
  }
);

function Rotas() {
  return <RouterProvider router={router} />;
}

export default Rotas;
